import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  'start.learning': {
    id: 'start.learning',
    defaultMessage: 'Vamos Aprender',
    description: 'Header text for logistration MFE pages',
  },
  'with.site.name': {
    id: 'with.site.name',
    defaultMessage: 'con {siteName}',
    description: 'Header text with site name for logistration MFE pages',
  },
});

export default messages;
